export default $axios => {
    return {
        $axios,

        async self() {
            return await $axios.get('/self');
        },

        async save(form) {
            return await $axios.put('/self', form);
        },

        async deleteAccount() {
            return await $axios.delete('/self');
        },

        async uploadImage(form) {
            return await $axios.post('/self/image', form);
        },

        async checkCoordinates(place_id) {
            return await $axios.post('/coordinates', {
                place_id
            });
        }
    };
};